import React, { useState } from 'react'
import { minimumPriceValidator } from 'modules/utils/validators'
import { Form, Input, InputNumber, Switch } from 'antd'

import './index.styl'

const { Item } = Form

const RaffleItems = ({ namePrefix, form }) => {
  const [availableTicket, setAvailableTicket] = useState(form.getFieldValue('showAvailableTickets') || false)

  const availableTicketHandler = () => {
    setAvailableTicket(!availableTicket)
    form.setFieldsValue({
      showAvailableTickets: !availableTicket,
    })
  }

  return (
    <>
      <div className='topField raffleItemsWrapper'>
        <div className='inputFields'>
          <Item
            rules={[{ required: true, message: 'Enter Ticket Category Name' }]}
            name={[namePrefix, 'name']}
            label='Ticket Category Name'
            initialValue={namePrefix === 0 ? 'Charity Raffle' : ''}

          >
            <Input className='inputName' />
          </Item>
          <div className='priceQuantityWrapper'>
            <div className='mobileFlex'>
              <Item
                name={[namePrefix, 'price']}
                label='Ticket Price'
                rules={[
                  { required: true, message: 'Enter price' },
                  minimumPriceValidator,
                ]}
              >
                <InputNumber placeholder='0' className='price' min={0} />
              </Item>
              <Item
                rules={[
                  { required: true, message: 'Enter quantity' },
                  { type: 'number', max: 100000, message: 'Quantity cannot exceed 100 000' },
                  {
                    validator: (_, value) =>
                      Number.isInteger(value) ? Promise.resolve() : new Promise((resolve, reject) => {
                        reject(new Error('Quantity must be an integer!'))
                      }),
                  },
                ]}
                name={[namePrefix, 'quantity']}
                label='Tickets Quantity'
              >
                <InputNumber
                  className='quantity'
                  placeholder='0'
                  min={0}
                />
              </Item>
            </div>
          </div>
        </div>
      </div>
      <div className='radioItemField'>
        <Item
          name={[namePrefix, 'showAvailableTickets']}
          valuePropName='checked'
          className='item'
          initialValue={availableTicket}
        >
          <Switch onChange={availableTicketHandler} defaultChecked={availableTicket} />
        </Item>
        <div className='text'>Show available tickets</div>
      </div>
      <div className='earlyBirdDateItem' />
    </>
  )
}

export default RaffleItems
